var Flickity = require("flickity");
require("flickity-fullscreen");
require("flickity-as-nav-for");
let imagesLoaded = require("imagesloaded");

$(".carousel-main").each(function () {
    let flickitySettings = {
        "fullscreen": true,
        "lazyLoad": 2,
        "pageDots": true,
        "adaptiveHeight": true,
        on: {
            ready: function () {

                $('.carousel-loader').hide();
                $(".carousel-main .carousel-cell picture").each(function () {
                    $('.carousel-loader').hide();
                    $(this).show();
                });

                $(".carousel-main.force-square-image .carousel-cell img").each(function () {
                    $(this).height($(".carousel-main.force-square-image .flickity-viewport").width());
                });
                $(".carousel-main.force-square-image .flickity-viewport").height($(".carousel-main .flickity-viewport").width());

                if ($(".carousel-main .carousel-cell").length <= 1) {
                    $(".carousel-main .flickity-prev-next-button.previous").hide();
                    $(".carousel-main .flickity-prev-next-button.next").hide();
                    $(".carousel-main .flickity-page-dots").hide();
                }
            },
            lazyLoad: function (event, cellElement) {
                let flickity = this;
                if (event.type == 'error') {
                    const img = $(cellElement).children('picture').children('img');
                    const imageLocalPath = img.data('image-local');
                    img.attr("src", imageLocalPath);
                    img.siblings().each(function () {
                        $(this).attr("srcset", imageLocalPath);
                    });
                    imagesLoaded(cellElement, function () {
                        $(".carousel-main.force-square-image .carousel-cell img").each(function () {
                            $(this).height($(".carousel-main.force-square-image .flickity-viewport").width());
                        });
                        $(".carousel-main.force-square-image .flickity-viewport").height($(".carousel-main .flickity-viewport").width());
                        flickity.reloadCells();
                    });
                }
            },
            fullscreenChange: function (event, cellElement) {
                let flickity = this;
                $(".carousel-main.force-square-image .carousel-cell img").each(function () {
                    $(this).height($(".carousel-main.force-square-image .flickity-viewport").width());
                });
                $(".carousel-main.force-square-image .flickity-viewport").height($(".carousel-main .flickity-viewport").width());
                flickity.reloadCells();
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    let carouselMain = new Flickity(this, flickitySettings);
});

$(".carousel-nav").each(function () {
    let flickitySettings = {
        "lazyLoad": 6,
        "asNavFor": ".carousel-main",
        "pageDots": false,
        "contain": true,
        "prevNextButtons": false,
        "cellAlign": 'left',
        on: {
            ready: function () {
                $(".carousel-nav .carousel-cell picture").each(function () {
                    $(this).show();
                });
            },
            lazyLoad: function (event, cellElement) {
                let flickity = this;
                flickity.reloadCells();
                if (event.type == 'error') {
                    const img = $(cellElement).children('picture').children('img');
                    const imageLocalPath = img.data('image-local');
                    img.attr("src", imageLocalPath);
                    img.siblings().each(function () {
                        $(this).attr("srcset", imageLocalPath);
                    });
                    imagesLoaded(cellElement, function () {
                        flickity.reloadCells();
                    });
                }
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    new Flickity(this, flickitySettings);
});

$(".carousel-catalog").each(function () {
    let flickitySettings = {
        "lazyLoad": 1,
        "wrapAround": true,
        "autoPlay": true,
        "setGallerySize": false,
        on: {
            ready: function () {
                $(".carousel-catalog .carousel-cell picture").each(function () {
                    $(this).show();
                });

                if ($(".carousel-catalog .carousel-cell").length <= 1) {
                    $(".carousel-catalog .flickity-prev-next-button.previous").hide();
                    $(".carousel-catalog .flickity-prev-next-button.next").hide();
                    $(".carousel-catalog .flickity-page-dots").hide();
                }
            },
            lazyLoad: function (event, cellElement) {
                let flickity = this;
                if (event.type == 'error') {
                    const img = $(cellElement).children('picture').children('img');
                    const imageLocalPath = img.data('image-local');
                    img.attr("src", imageLocalPath);
                    img.siblings().each(function () {
                        $(this).attr("srcset", imageLocalPath);
                    });
                    imagesLoaded(cellElement, function () {
                        flickity.reloadCells();
                    });
                }
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    new Flickity(this, flickitySettings);
});

document.addEventListener("flickity-content-loaded", function (e) {
    $(".carousel-content").each(function () {
        let flickitySettings = {
            "lazyLoad": 1,
            "wrapAround": true,
            "autoPlay": true,
            on: {
                ready: function () {
                    $(".carousel-content .carousel-cell picture").each(function () {
                        $(this).show();
                    });
                    if ($(".carousel-content .carousel-cell").length <= 1) {
                        $(".carousel-content .flickity-prev-next-button.previous").hide();
                        $(".carousel-content .flickity-prev-next-button.next").hide();
                        $(".carousel-content .flickity-page-dots").hide();
                    }
                },
                lazyLoad: function (event, cellElement) {
                    let flickity = this;
                    if (event.type == 'error') {
                        const img = $(cellElement).children('picture').children('img');
                        const imageLocalPath = img.data('image-local');
                        img.attr("src", imageLocalPath);
                        img.siblings().each(function () {
                            $(this).attr("srcset", imageLocalPath);
                        });

                        imagesLoaded(cellElement, function () {
                            flickity.reloadCells();
                        });
                    }
                }
            }
        };

        let customFlickitySettings = $(this).data("flickity");
        flickitySettings = {...flickitySettings, ...customFlickitySettings}

        let flickityBlockSettings = $(this).data("flickity-additional-block-settings");
        flickitySettings = {...flickitySettings, ...flickityBlockSettings}

        new Flickity(this, flickitySettings);
    });

    //slider widget lista categorie
    $(".carousel-catalog-list").each(function () {
        let flickitySettings = {
            "groupCells": true,
            on: {
                ready: function () {
                    $(".carousel-catalog-list .carousel-cell picture").each(function () {
                        $(this).show();
                    });

                    var height = this.maxCellHeight;
                    $(".carousel-catalog-list .carousel-cell").each(function () {
                        $(this).height(height);
                    });

                    $(".carousel-catalog-list .carousel-cell > *").each(function () {
                        $(this).outerHeight(height);
                    });
                },
                lazyLoad: function (event, cellElement) {
                    let flickity = this;
                    if (event.type == 'error') {
                        const img = $(cellElement).children('picture').children('img');
                        const imageLocalPath = img.data('image-local');
                        img.attr("src", imageLocalPath);
                        img.siblings().each(function () {
                            $(this).attr("srcset", imageLocalPath);
                        });
                        imagesLoaded(cellElement, function () {
                            flickity.reloadCells();
                        });
                    }
                }
            }
        };

        let customFlickitySettings = $(this).data("flickity");
        flickitySettings = {...flickitySettings, ...customFlickitySettings}

        let flickityBlockSettings = $(this).data("flickity-additional-block-settings");
        flickitySettings = {...flickitySettings, ...flickityBlockSettings}

        new Flickity(this, flickitySettings);
    });

    //slider widget lista prodotti
    $(".carousel-product-list").each(function () {
        let flickitySettings = {
            "groupCells": true,
            on: {
                ready: function () {
                    $(".carousel-product-list .carousel-cell picture").each(function () {
                        $(this).show();
                    });

                    var height = this.maxCellHeight;
                    $(".carousel-product-list .carousel-cell").each(function () {
                        $(this).height(height);
                    });

                    $(".carousel-product-list .carousel-cell > *").each(function () {
                        $(this).outerHeight(height);
                    });
                },
                lazyLoad: function (event, cellElement) {
                    let flickity = this;
                    if (event.type == 'error') {
                        const img = $(cellElement).children('picture').children('img');
                        const imageLocalPath = img.data('image-local');
                        img.attr("src", imageLocalPath);
                        img.siblings().each(function () {
                            $(this).attr("srcset", imageLocalPath);
                        });
                        imagesLoaded(cellElement, function () {
                            flickity.reloadCells();
                        });
                    }
                }
            }
        };

        let customFlickitySettings = $(this).data("flickity");
        flickitySettings = {...flickitySettings, ...customFlickitySettings}

        let flickityBlockSettings = $(this).data("flickity-additional-block-settings");
        flickitySettings = {...flickitySettings, ...flickityBlockSettings}

        new Flickity(this, flickitySettings);
    });
});

$(".go-to-image-color").on("click", function () {
    const codeColors = $(this).attr("data-color-code");

    if (codeColors && codeColors.length) {
        const flk = Flickity.data('.carousel-main');
        let index = 0;
        let found = false;

        // split dei valori separati da virgole e rimozione di eventuali spazi
        const colorList = codeColors.split(",").map(c => c.trim());

        $(".carousel-main .flickity-slider .flickity-cell").each(function (i) {
            const dataCode = $(this).attr("data-code");

            // per ogni colore, controlla se corrisponde
            for (let color of colorList) {
                if (dataCode.indexOf(color) >= 0) {
                    index = i;
                    found = true;
                    return false; // esce dal .each
                }
            }
        });

        if (found) {
            flk.stopPlayer();
            flk.select(index);
        }
    }
});
